export default __webpack_public_path__ + "static/media/check-mark.2cd51ec0.svg";